import { render } from "./MOptionCard.vue?vue&type=template&id=0c59e2b8"
import script from "./MOptionCard.vue?vue&type=script&lang=js"
export * from "./MOptionCard.vue?vue&type=script&lang=js"

import "./MOptionCard.vue?vue&type=style&index=0&id=0c59e2b8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__